function buildHubspotPayload(user) {
  const { firstName, lastName, email } = user;
  return {
    firstname: {
      value: firstName || 'N/A',
      color: 'success',
    },
    lastname: {
      value: lastName || 'N/A',
      color: 'success',
    },
    email: {
      value: email,
      color: 'success',
    },
    /* Since these fields are sometimes not present in the db,
       we will keep them as N/A, since this is an auto-filled and auto-submitted form
    */
    company: {
      value: 'N/A',
      color: 'success',
    },
    phone: {
      value: 'N/A',
      color: 'success',
    },
    jobtitle: {
      value: 'N/A',
      color: 'success',
    },
    contact_country__c: {
      value: 'N/A',
      color: 'success',
    },
  };
}

const cleanUpFormFields = (programId, formFields) => {
  let editedFormFields = formFields.filter(
    field => field.id !== 'HubSpotForm__most_recent_lead_source__c' && field.id !== 'HubSpotForm__program'
  );
  const leadSource = formFields.find(field => field.id === 'HubSpotForm__most_recent_lead_source__c');
  const hubspotProgram = formFields.find(field => field.id === 'HubSpotForm__program');

  if (leadSource) {
    leadSource.hidden = false;
    leadSource.defaultValue = 'Contact Sales';
    editedFormFields.push(leadSource);
  }

  if (hubspotProgram) {
    hubspotProgram.hidden = false;
    hubspotProgram.defaultValue = programId;
    editedFormFields.push(hubspotProgram);
  }
  // Clean up any undefined
  editedFormFields = editedFormFields.filter(form => form);

  return editedFormFields;
};

export { buildHubspotPayload, cleanUpFormFields };
